import React, { createContext, useContext, useState } from "react";

const ConfirmationContext = createContext();

export const useConfirmation = () => useContext(ConfirmationContext);

export const ConfirmationProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [confirmationConfig, setConfirmationConfig] = useState({});

  const openConfirmation = (config) => {
    setConfirmationConfig(config);
    setIsOpen(true);
  };

  const closeConfirmation = () => {
    setIsOpen(false);
  };

  return (
    <ConfirmationContext.Provider
      value={{
        isOpen,
        confirmationConfig,
        openConfirmation,
        closeConfirmation,
      }}
    >
      {children}
    </ConfirmationContext.Provider>
  );
};
